import { api } from '../client';

export const WELL_STATUSES = [
  'PLANNED',
  'DRILLING',
  'COMPLETING',
  'PRODUCING',
  'SUSPENDED',
  'PLUGGED',
] as const;

export type WellStatus = (typeof WELL_STATUSES)[number];

export interface Well {
  id: string;
  apiNumber: string;
  name: string;
  wellNumber?: string | null;
  leaseName?: string | null;
  fieldName?: string | null;
  basin?: string | null;
  /** The operator. We are the service company; we do not own the well. */
  operatorName?: string | null;
  status: WellStatus;
  location?: { id: string; name: string } | null;
  /** Material consumed across every job on this well, at our carrying value. */
  consumedCost?: number;
  _count?: { jobs: number };
}

export interface WellDetail extends Well {
  jobs: Array<{
    id: string;
    jobNumber: string;
    name: string;
    status: string;
    jobType?: string | null;
    afeNumber?: string | null;
    customerName?: string | null;
    plannedBaseMetric?: number | null;
    baseMetricUnit?: string | null;
    startDate?: string | null;
    endDate?: string | null;
    consumedCost: number;
    chargeCount: number;
  }>;
  lifetime: {
    jobCount: number;
    consumedCost: number;
    chargeCount: number;
    /** What the figure is and, importantly, what it is not. */
    basis: string;
  };
}

export const wellsApi = {
  async getAll(search?: string) {
    const response = await api.get<Well[]>('/wells', {
      params: search ? { search } : undefined,
    });
    return response.data;
  },

  async getById(id: string) {
    const response = await api.get<WellDetail>(`/wells/${id}`);
    return response.data;
  },
};
